<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/hello' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>数据显示管理</el-breadcrumb-item>
      <el-breadcrumb-item>数据类型配置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card style="margin-top:15px;">
      <el-form
        ref="queryForm"
        :model="userSearchData"
        size="small"
        :inline="true"
        label-width="68px"
      >
        <el-form-item label="统计类型">
          <el-select
            v-model="userSearchData.type"
            clearable
            style="width: 150px"
          >
            <el-option label="总计统计" value="0"/>
            <el-option label="游戏统计" value="1"/>
          </el-select>
        </el-form-item>
        <el-form-item label="字段名称">
            <el-input
              v-model="userSearchData.name"
              placeholder="请输入字段名称"
              size="small"
              clearable
              style="width:150px;"
            ></el-input>
        </el-form-item>
        <el-form-item label="字段描述">
            <el-input
              v-model="userSearchData.type_desc"
              placeholder="请输入字段描述"
              size="small"
              clearable
              style="width:150px;"
            ></el-input>
        </el-form-item>
        <el-form-item label="时间">
          <el-date-picker
            v-model="userSearchData.time"
            style="width: 220px"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="searchDataInfo()"
            >搜索</el-button>
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-plus"
            @click="addversion"
            >新增</el-button>
        </el-form-item>
      </el-form>
      <!-- 表格 -->
      <el-table v-loading="pageloading" border :data="versionListData" stripe style="width: 100%">
        <el-table-column prop="Id" label="序列号" width="80"></el-table-column>
        <el-table-column prop="type" label="统计类型" width="120">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.type == 0">总计统计</el-tag>
            <el-tag type="success" v-if="scope.row.type == 1">游戏统计</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称" width="160"></el-table-column>
        <el-table-column prop="type_desc" label="描述" width="160"></el-table-column>
        <el-table-column prop="type_value" label="数据类型" width="100">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.type_value == -1">不选择</el-tag>
            <el-tag type="success" v-if="scope.row.type_value == 0">整型</el-tag>
            <el-tag type="success" v-if="scope.row.type_value == 1">浮点型</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="tb_name" label="表明" width="200"></el-table-column>
        <el-table-column prop="tb_item_name" label="列名" width="200"></el-table-column>
        <el-table-column prop="sort" label="排序" width="80"></el-table-column>
        <el-table-column prop="is_qujian" label="区间状态" width="80">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.status == 0">没有区间</el-tag>
            <el-tag type="success" v-if="scope.row.status == 1">有区间</el-tag>
            <el-tag type="danger" v-else>不选择</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="s_value" label="区间开始值" width="80">
        </el-table-column>
        <el-table-column prop="e_value" label="区间结束值" width="80">
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间"  width="180">
          <template slot-scope="scope">
            {{changeDateFormat(scope.row.create_time)}}
          </template>
        </el-table-column>
        <el-table-column prop="update_time" label="更新时间"  width="180">
          <template slot-scope="scope">
            {{changeDateFormat(scope.row.update_time)}}
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作" width="450" fixed="right">
          <template slot-scope="scope">
            <el-button type="warning" size="mini" @click="upSort(scope.row)">
              <img src="../../../static/upsort.png" alt="向上移动" style="width: 16px; height: 16px; vertical-align: middle;">
              向上移动
            </el-button>
            <el-button type="warning" size="mini" @click="downSort(scope.row)">
              <img src="../../../static/downsort.png" alt="向下移动" style="width: 16px; height: 16px; vertical-align: middle;">
              向下移动
            </el-button>
            <el-button type="success" size="mini" @click="edit(scope.row)"
              >编辑</el-button>
            <el-button type="danger" size="mini" @click="deleteDataInfo(scope.row)"
                >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页功能 -->
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      >
      </el-pagination>
      <!-- 分页功能 -->
    </el-card>

    <!-- 添加版本弹框 -->
    <el-dialog v-loading="editpageloading" title="新增信息" :visible.sync="addVisible" width="50%">
      <el-form
        :model="addruleForm"
        ref="addruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="统计类型" prop="type">
          <el-radio-group v-model="addruleForm.type">
            <el-radio label="0">总计统计</el-radio>
            <el-radio label="1">游戏统计</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="字段名称" prop="name">
          <el-input v-model="addruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="字段描述" prop="type_desc">
          <el-input v-model="addruleForm.type_desc"></el-input>
        </el-form-item>
        <el-form-item label="数据类型" prop="type_value">
          <el-radio-group v-model="addruleForm.type_value">
            <el-radio label="-1">不选择</el-radio>
            <el-radio label="0">整型</el-radio>
            <el-radio label="1">浮点型</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="表名" prop="tb_name">
          <el-input v-model="addruleForm.tb_name"></el-input>
        </el-form-item>
        <el-form-item label="列名" prop="tb_item_name">
          <el-input v-model="addruleForm.tb_item_name"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="addruleForm.sort"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addsubmitForm('addruleForm')"
            >添加内容</el-button
          >
          <el-button @click="addresetForm('addruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 添加版本弹框 -->

    <!-- 编辑版本弹框 -->
    <el-dialog  v-loading="editpageloading" title="编辑APP弹框信息" :visible.sync="editVisible" width="50%">
      <el-form
        :model="editruleForm"
        ref="editruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="统计类型" prop="type">
          <el-radio-group v-model="editruleForm.type">
            <el-radio :label="0">总计统计</el-radio>
            <el-radio :label="1">游戏统计</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="字段名称" prop="name">
          <el-input v-model="editruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="字段描述" prop="type_desc">
          <el-input v-model="editruleForm.type_desc"></el-input>
        </el-form-item>
        <el-form-item label="数据类型" prop="type_value">
          <el-radio-group v-model="editruleForm.type_value">
            <el-radio :label="-1">不选择</el-radio>
            <el-radio :label="0">整型</el-radio>
            <el-radio :label="1">浮点型</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="表名" prop="tb_name">
          <el-input v-model="editruleForm.tb_name"></el-input>
        </el-form-item>
        <el-form-item label="列名" prop="tb_item_name">
          <el-input v-model="editruleForm.tb_item_name"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="editruleForm.sort"></el-input>
        </el-form-item>
        <el-form-item label="区间类型" prop="is_qujian">
          <el-radio-group v-model="editruleForm.is_qujian">
            <el-radio label="-1">不选择</el-radio>
            <el-radio label="0">没有区间</el-radio>
            <el-radio label="1">区间</el-radio>            
          </el-radio-group>
        </el-form-item>
        <el-form-item label="区间开始值" prop="s_value">
          <el-input v-model="editruleForm.s_value"></el-input>
        </el-form-item>
        <el-form-item label="区间结束值" prop="e_value">
          <el-input v-model="editruleForm.e_value"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="editsubmitForm('editruleForm')"
            >提交修改</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 编辑弹框 -->
  </div>
</template>

<script>
// import { changeDateFormat } from "@/utils/util";
import { getcurrentTime } from "@/utils/public";
import { isString } from '../../utils/util';
export default {
  data() {
    return {
      pageloading: false,
      editpageloading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0, //请求列表的总条数
      userSearchData: {
        type: 0,
        name: "",
        type_desc: "",
        time: ""
      },
      // 添加版本信息数据
      addruleForm: {
        type: 0,
        name: "",
        type_desc: "",
        type_value: -1,
        tb_name: "",
        tb_item_name: "",
        sort: 0
      },
      // 修改版本信息数据
      editruleForm: {
        id: "",
        type: 0,
        name: "",
        type_desc: "",
        type_value: -1,
        tb_name: "",
        tb_item_name: "",
        is_qujian: -1,
        s_value: "",
        e_value: "",
        sort: 0
      },
      tableData: [],
      versionListData: [],
      addVisible: false,
      editVisible: false
    };
  },

  mounted() {
    this.searchDataInfo();
  },

  methods: {
    changeDateFormat(time, format = 'YYYY-MM-DD hh:mm:ss') {
      if(!time) return '';
      var datetime = new Date(time);
      var o = {
          'Y+': datetime.getFullYear(),
          "M+": datetime.getMonth() + 1,
          "D+": datetime.getDate(),
          "h+": datetime.getHours(),
          "m+": datetime.getMinutes(),
          "s+": datetime.getSeconds(),
          "q+": Math.floor((datetime.getMonth() + 3) / 3),
          "S": datetime.getMilliseconds()
      };
      if (/(Y+)/.test(format)) format = format.replace(RegExp.$1, (datetime.getFullYear() + "").substr(4 - RegExp.$1.length));
      for (var k in o) {
          if (new RegExp("(" + k + ")").test(format)) {
              format = format.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
          }
      }
      return format;
    },
    getAppName(item) {
      var string = ``;
      if (isString(item)) {
        for(var i=0; i<this.appids.length; i++) {
          var itemObject = this.appids[i];
          if (itemObject.app_id == item) {
            string = itemObject.name;
            break;
          }
        }
      }      
      return string;
    },
    // 添加用户弹框
    addversion() {
      this.addVisible = true;
    },
    // 添加用户按钮
    addsubmitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let time = getcurrentTime();
          this.addruleForm.create_time = time;
          console.log(this.addruleForm);
          //添加版本
          this.addVersionData(this.addruleForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 重置添加用户
    addresetForm(formName) {
      this.$refs[formName].resetFields();
    },

    // 点击编辑行内容并更改数据
    edit(data) {
      this.editVisible = true;
      for(var k in data) {
        this.editruleForm[k] = data[k];
      }
      this.editruleForm.id = Number.parseInt(data.Id);
      this.editruleForm.app_name = this.getAppName(data.app_id);
      this.editruleForm.name = this.getChannelName(data.channel_id);
    },
    editsubmitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.editVisible = false;
          this.updateDataInfo(this.editruleForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    editresetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 编辑version
    async updateDataInfo(requestObject) {
      this.$axios
        .post("/3699BIApi/DataTypeConfig/UpdateData",{
            id: requestObject.id,
            type: Number.parseInt(requestObject.type),
            name: requestObject.name,
            type_desc: requestObject.type_desc,
            type_value: Number.parseInt(requestObject.type_value),
            tb_name: requestObject.tb_name,
            tb_item_name: requestObject.tb_item_name,
            is_qujian: Number.parseInt(requestObject.is_qujian),
            s_value: Number.parseInt(requestObject.s_value),
            e_value: Number.parseInt(requestObject.e_value),
            sort: Number.parseInt(requestObject.sort)
        })
        // 判断返回信息的状态码并重新请求数据更新页面
        .then(res => {
          if (res.data.code == "200") {
            this.$message.success("编辑成功");
            this.searchDataInfo();
          } else {
            this.$message.error("编辑失败");
          }
        });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.searchData(this.userSearchData);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.searchData(this.userSearchData);
    },
    async addVersionData(requestObject) {
      this.editpageloading = true;
      this.$axios
      .post("/3699BIApi/DataTypeConfig/AddData",{
          type: Number.parseInt(requestObject.type),
          name: requestObject.name,
          type_desc: requestObject.type_desc,
          type_value: Number.parseInt(requestObject.type_value),
          tb_name: requestObject.tb_name,
          tb_item_name: requestObject.tb_item_name,
          sort: Number.parseInt(requestObject.sort)
      })
      .then(res => {
        this.editpageloading = false;
        if (res.data.code == "200") {
          this.addVisible = false;
          this.searchDataInfo();
          this.$message('添加成功！');
        }
        else {
          console.log(res.data.message);
          this.$message.error(`添加失败:${res.data.message}`);
        }
      });
    },
    async searchData(requestObject) {
      this.$axios
      .post("/3699BIApi/DataTypeConfig/SearchData",{
          type: Number.parseInt(requestObject.type),
          name: requestObject.name,
          type_desc: requestObject.type_desc,
          create_time: requestObject.time[0],
          update_time: requestObject.time[1],
          currentPage: this.currentPage,
          pageSize: this.pageSize
      })
      .then(res => {
          this.pageloading = false;
          this.tableData = res.data.list;
          this.total = res.data.total;
          this.updateCurrpageData();
      });
    },
    searchDataInfo() {
      this.pageloading = true;
      this.searchData(this.userSearchData);
    },
    updateCurrpageData() {
      var arrays = [];
      var i = 0;
      var endi = this.total - (this.currentPage-1) * this.pageSize;
      if (endi > this.pageSize) {
        endi = this.pageSize;
      }
      console.log(`updateCurrpageData ${endi} 条`);
      for(; i<endi; i++) {
        if (i < this.total) {
          var itemObject = this.tableData[i];
          arrays.push(itemObject);
        }
      }
      
      this.versionListData = arrays.filter(val => {
        return val;
      });
    },
    async deleteDataInfo(data) {
      this.deleteData(data);
    },  
    // 删除
    async deleteData(data) {
      try {
        let msg = await this.$confirm("确认删除吗?");
        if (msg =  `confirm`) {
          this.deleteDataApi(data);
        }
      } catch (error) {
        return console.log("出错了：" + error);
      }
    },
    // 删除
    async deleteDataApi(data) {
      this.editpageloading = true;
      this.$axios
        .post("/3699BIApi/DataTypeConfig/DeleteData",{
          id: Number.parseInt(data.Id)
        })
        // 判断返回信息的状态码并重新请求数据更新页面
        .then(res => {
          this.pageloading = false;
          if (res.data.code == "200") {
            this.$message.success("删除成功");
            this.searchDataInfo();
          } else {
            this.$message.error("删除失败");
          }
        },
        (error)=>{
          this.editpageloading = false;
          this.$message('请求报错：' + error);
        });
    },
    // 向上移动
    async upSort(data) {
      this.editpageloading = true;
      this.$axios
        .post("/3699BIApi/DataTypeConfig/SortData",{
          id: Number.parseInt(data.Id),
          type: Number.parseInt(this.userSearchData.type),
          sort: 7
        })
        // 判断返回信息的状态码并重新请求数据更新页面
        .then(res => {
          this.pageloading = false;
          if (res.data.code == "200") {
            this.searchDataInfo();
          } else {
            this.$message.error("移动失败");
          }
        },
        (error)=>{
          this.editpageloading = false;
          this.$message('请求报错：' + error);
        });
    },
    // 向下移动
    async downSort(data) {
      this.editpageloading = true;
      this.$axios
        .post("/3699BIApi/DataTypeConfig/SortData",{
          id: Number.parseInt(data.Id),
          type: Number.parseInt(this.userSearchData.type),
          sort: 8
        })
        // 判断返回信息的状态码并重新请求数据更新页面
        .then(res => {
          this.pageloading = false;
          if (res.data.code == "200") {
            this.searchDataInfo();
          } else {
            this.$message.error("移动失败");
          }
        },
        (error)=>{
          this.editpageloading = false;
          this.$message('请求报错：' + error);
        });
    },
  }
};
</script>

<style lang="sass" scoped></style>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         


// WEBPACK FOOTER //
// src/views/ShowConfig/DataTypeConfig.vue